// extracted by mini-css-extract-plugin
export default {"wrapper":"DonutChart_wrapper__LLwSv"};